import React from 'react';

export interface NotionPropertyRowProps {
  label: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const NotionPropertyRow: React.FC<NotionPropertyRowProps> = ({
  label,
  icon,
  children,
  className = '',
}) => {
  return (
    <div
      className={`grid grid-cols-[180px_1fr] border-b border-slate-200 py-2 px-0 hover:bg-slate-50 transition-colors ${className}`}
    >
      <div className="flex items-center gap-2 text-sm text-slate-600 pl-1 pr-4">
        {icon && <span className="w-4 h-4 flex items-center justify-center opacity-60">{icon}</span>}
        <span className="font-medium">{label}</span>
      </div>
      <div className="flex items-center gap-2 text-sm text-slate-900">
        {children}
      </div>
    </div>
  );
};
